
import { Box, Container, Stack, Divider, Button, CardActions, Card, Typography, Avatar, Unstable_Grid2 as Grid, CardContent, CardHeader, TextField } from '@mui/material';
import { Layout as DashboardLayout } from 'src/layouts/dashboard/layout';
import authService from 'src/services/authService';
import { useCallback, useEffect, useState } from 'react';
import { format } from 'date-fns';
import UpdateProfilePopup from './updateAccountPopUp';
const Account = () => {
  const [user, setUser] = useState();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    userDetail();
  }, [])
  const userDetail = async () => {
    await authService.getUserDetail().then((res) => {
      if (res.status == 200) {

        setUser(res.data.admin);
      }
    })
  }
  const handleChange = useCallback(
    (event) => {
      setValues((prevState) => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
    },
    []
  );


  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      {user && (
        <>

          <Box
            component="main"
            sx={{
              flexGrow: 1,
              py: 8
            }}
          >
            <Container maxWidth="lg">
              <Stack spacing={3}>
                <div>
                  <Typography variant="h4">
                    Account
                  </Typography>
                </div>
                <div>
                  <Grid
                    container
                    spacing={3}
                  >
                    <Grid
                      xs={12}
                      md={6}
                      lg={4}
                    >
                      <Card>
                        <CardContent>
                          <Box
                            sx={{
                              alignItems: 'center',
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <Avatar
                              src={user.image_url}
                              sx={{
                                height: 80,
                                mb: 2,
                                width: 80
                              }}
                            />
                            <Typography
                              gutterBottom
                              variant="h5"
                            >
                              Full Name:   {user.full_name}
                            </Typography>
                            <Typography
                              color="text.secondary"
                              variant="body2"
                            >
                              Email:    {user.email}
                            </Typography>
                            <Typography
                              color="text.secondary"
                              variant="body2"
                            >

                              Created At:     {format(new Date(user.created_at), 'dd/MM/yyyy')}
                            </Typography>
                          </Box>
                        </CardContent>
                        <Divider />

                      </Card>
                    </Grid>
                    <Grid
                      xs={12}
                      md={6}
                      lg={8}
                    >

                      <Card>
                        <CardHeader
                          subheader="The information can be edited"
                          title="Profile"
                        />
                        <CardContent sx={{ pt: 0 }}>
                          <Box sx={{ m: -1.5 }}>
                            <Grid
                              container
                              spacing={3}
                            >
                              <Grid
                                xs={12}
                                md={6}
                              >
                                <h2
                                  fullWidth
                                  helperText="Please specify the first name"
                                  label="Full name"
                                  name="firstName"

                                >
                                  Full Name:
                                  <br />
                                  {
                                    user.full_name
                                  }
                                </h2>
                              </Grid>
                              <Grid
                                xs={12}
                                md={6}
                              >
                              </Grid>
                              <Grid
                                xs={12}
                                md={6}
                              >
                                <h2
                                  fullWidth
                                  label="Email Address"
                                  name="email"

                                >
                                  Email:
                                  <br />
                                  {
                                    user.email
                                  }
                                </h2>
                              </Grid>
                            </Grid>
                          </Box>
                          <button
                          onClick={togglePopup}
                            className="bg-indigo-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                          >
                            Update
                          </button>
                        </CardContent>
                        <Divider />
                      </Card>

                    </Grid>
                  </Grid>
                </div>
              </Stack>
            </Container>
          </Box>
        </>
      )}
      {
        isOpen && (
          <UpdateProfilePopup isOpen={isOpen} onClose={togglePopup} profilePictureDetails={user} />
        )
      }
    </>
  );
};


export default Account;
